const WAREHOUSE_ROLE_IDS = [9, 10, 11, 12, 13];

function normalizeRoles(roles) {
  if (!roles || roles.length <= 1) return roles || [];
  return [...roles].sort((a, b) => {
    const aIsWarehouse = WAREHOUSE_ROLE_IDS.includes(a.id);
    const bIsWarehouse = WAREHOUSE_ROLE_IDS.includes(b.id);
    if (aIsWarehouse === bIsWarehouse) return 0;
    return aIsWarehouse ? 1 : -1;
  });
}

/**
 * Create a new user object
 * @param {int} id Id
 * @param {string} id_string Id int to string
 * @param {string} full_name Full name
 */
export function user(props) {
  return {
    full_name: props.name,
    id: props.id,
    is_active: props.is_active,
    email: props.email,
    reference_id: props.reference_id,
    phone_number: props.phone_number,
    customer_id: props.customer_id,
    start_date: props.start_date,
    contact: props.contact
      ? {
          id: props.contact.id,
          first_name: props.contact.first_name,
          last_name: props.contact.last_name,
          phone_number: props.contact.phone_number,
          date_of_birth: props.contact.date_of_birth,
          gender: props.contact.gender
        }
      : null,
    roles: normalizeRoles(props.roles),
    time_sheet_status: props.time_sheet_status,
    office: props.office
      ? {
          id: props.office.id,
          name: props.office.name
        }
      : null,
    offices: props.offices,
    hr_privilege: props.hr_privilege,
    supervisor_privilege: props.supervisor_privilege,
    wallet_transfer_initiate: props.wallet_transfer_initiate,
    wallet_transfer_approve: props.wallet_transfer_approve,
    wallet_transfer_view: props.wallet_transfer_view,
    partner_id: props.partner_id,
  };
}
